import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ChatInterfaceComponent} from '../chat-interface/chat-interface.component';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

@Component({
  selector: 'app-chat-button',
  templateUrl: './chat-button.component.html',
  styleUrls: ['./chat-button.component.scss']
})
export class ChatButtonComponent implements OnInit, OnDestroy {

  disableButton = false;
  private routeSubscription!: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver // Inject BreakpointObserver
  ) {
  }

  ngOnInit(): void {
    // Initial check
    this.checkCurrentUrl();

    // Subscribe to future navigation events
    this.routeSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkCurrentUrl();
    });
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  private checkCurrentUrl(): void {
    const urlSegments = this.activatedRoute.snapshot.url;
    this.disableButton = urlSegments.length > 0 && urlSegments[0].path === 'chat';

    // If we're not at the root level route, check the first segment of the URL
    if (urlSegments.length === 0 && this.router.url.includes('/chat')) {
      this.disableButton = true;
    }
  }

  openChatDialog(): void {
    // Check the current screen size synchronously
    const isMobile = this.breakpointObserver.isMatched([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]);

    const dialogConfig = {
      width: isMobile ? '100vw' : '80%',
      height: isMobile ? '100vh' : '80%',
      maxWidth: isMobile ? '100vw' : undefined, // Override default max-width on mobile
      maxHeight: isMobile ? '100vh' : undefined, // Override default max-height on mobile
      panelClass: isMobile ? 'mobile-chat-dialog' : undefined // Optional class for mobile-specific styles
    };

    this.dialog.open(ChatInterfaceComponent, dialogConfig);
  }
}
